import { AppProvider, useAppContext } from './context/AppContext';
import ErrorBoundary from './components/ErrorBoundary';
import SignInBanner from './components/SignInBanner/SignInBanner';
import Header from './components/Header/Header';
import FilterBar from './components/FilterBar/FilterBar';
import MainGrid from './views/MainGrid/MainGrid';
import LocationView from './views/LocationView/LocationView';
import LocationManager from './views/LocationManager/LocationManager';
import HuntListView from './views/HuntListView/HuntListView';
import SharedView from './views/SharedView/SharedView';
import NumberDetailModal from './modals/NumberDetailModal/NumberDetailModal';
import AddPhotoModal from './modals/AddPhotoModal/AddPhotoModal';
import ImportModal from './modals/ImportModal/ImportModal';
import ShareModal from './modals/ShareModal/ShareModal';
import NewHuntModal from './modals/NewHuntModal/NewHuntModal';
import ManageHuntsModal from './modals/ManageHuntsModal/ManageHuntsModal';
import { exportData } from './lib/exportImport';
import { useGridLayers } from './hooks/useGridLayers';
import { useTheme } from './hooks/useTheme';
import './index.css';

function PhotoHunterInner() {
  const { state, dispatch } = useAppContext();
  const { layers, toggleLayer } = useGridLayers();
  const { theme, toggleTheme } = useTheme();

  function handleExport() {
    exportData().catch(err => console.error('Export failed:', err));
  }

  function handleImport() {
    dispatch({ type: 'OPEN_MODAL', modal: 'import' });
  }

  const { activeView, openModal, loading } = state;

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100dvh' }}>
        <p style={{ color: 'var(--muted)', fontSize: '0.9rem' }}>Loading…</p>
      </div>
    );
  }

  return (
    <>
      <SignInBanner />
      <Header onExport={handleExport} onImport={handleImport} theme={theme} toggleTheme={toggleTheme} />
      {activeView === 'grid' && <FilterBar layers={layers} toggleLayer={toggleLayer} />}

      {activeView === 'grid'      && <MainGrid layers={layers} />}
      {activeView === 'location'  && <LocationView />}
      {activeView === 'locations' && <LocationManager />}
      {activeView === 'hunt'      && <HuntListView />}

      {openModal === 'detail'   && <NumberDetailModal layers={layers} />}
      {openModal === 'addPhoto' && <AddPhotoModal />}
      {openModal === 'import'   && <ImportModal />}
      {openModal === 'share'    && <ShareModal />}
      {openModal === 'newHunt'  && <NewHuntModal />}
      {openModal === 'manageHunts' && <ManageHuntsModal />}
    </>
  );
}

export default function App() {
  // Handle share links: /share/{token} renders a standalone read-only view
  const shareMatch = window.location.pathname.match(/^\/share\/([^/]+)/);
  if (shareMatch) {
    return <SharedView token={shareMatch[1]} />;
  }

  return (
    <ErrorBoundary>
      <AppProvider>
        <PhotoHunterInner />
      </AppProvider>
    </ErrorBoundary>
  );
}
